import React from "react";
import usePublicNavbar from "./use-public-navbar";
import FormButton from "~/shared/form/FormButton";
import PublicPage from "./PublicPage";

export default function NotFound() {
    return (
        <PublicPage title="Page Not Found" navBar={usePublicNavbar()}>
            <p className="text-neutral-600">The link you used may be broken, or the page you were looking for might have moved.</p>
            <FormButton linkTo="/" formless className="mt-6 mx-auto">Return to Homepage</FormButton>
        </PublicPage>
    );
}
